"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StationActionButtons = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const copyLinkIcon_svg_1 = __importDefault(require("../../../../../assets/icons/copyLinkIcon.svg"));
const download_svg_1 = __importDefault(require("../../../../../assets/icons/download.svg"));
const ActionButton_style_1 = require("../../../../atoms/ActionButton/ActionButton.style");
const Button_style_1 = require("../../../../atoms/Button/Button.style");
const CopyLinkComponent_1 = require("../../../../molecules/Popups/CopyLinkComponent");
const ExportDataComponent_1 = require("../../../../molecules/Popups/ExportDataComponent");
const S = __importStar(require("./StationActionButtons.style"));
const StationActionButtons = ({ sessionId, sensorName }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(S.MobileButtons, null,
            react_1.default.createElement(ExportDataComponent_1.ExportDataComponent, { button: react_1.default.createElement(ActionButton_style_1.ActionButton, { onClick: () => { }, "aria-labelledby": t("calendarHeader.altExportSession") },
                    react_1.default.createElement("img", { src: download_svg_1.default, alt: t("calendarHeader.altExportSession") })), sessionsIds: [sessionId], sensorName: sensorName, isIconOnly: true, onSubmit: (formData) => { }, fixedSessionTypeSelected: true, isSessionList: false }),
            react_1.default.createElement(CopyLinkComponent_1.CopyLinkComponent, { button: react_1.default.createElement(ActionButton_style_1.ActionButton, { "aria-label": t("calendarHeader.altShareLink") },
                    react_1.default.createElement("img", { src: copyLinkIcon_svg_1.default, alt: t("calendarHeader.altCopyIcon") })), isIconOnly: true })),
        react_1.default.createElement(S.DesktopButtons, null,
            react_1.default.createElement(CopyLinkComponent_1.CopyLinkComponent, { button: react_1.default.createElement(Button_style_1.Button, { "aria-label": t("calendarHeader.altShareLink") },
                    t("calendarHeader.copyLink"),
                    react_1.default.createElement("img", { src: copyLinkIcon_svg_1.default, alt: t("calendarHeader.altCopyIcon") })), isIconOnly: false }),
            react_1.default.createElement(ExportDataComponent_1.ExportDataComponent, { button: react_1.default.createElement(Button_style_1.Button, { "aria-labelledby": t("calendarHeader.altExportSession") },
                    t("calendarHeader.exportSession"),
                    " ",
                    react_1.default.createElement("img", { src: download_svg_1.default, alt: "" })), sessionsIds: [sessionId], sensorName: sensorName, isIconOnly: false, onSubmit: (formData) => { }, fixedSessionTypeSelected: true, isSessionList: false }))));
};
exports.StationActionButtons = StationActionButtons;
